export const breakpoints = {
  xsmall: 380,
  small: 520,
  medium: 768,
  large: 1024,
  xlarge: 1200,
}
